import classNames from 'classnames'
import {ButtonHTMLAttributes, FC} from 'react'

export interface AnnouncementPillProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Text rendered inside the pill. */
  label: string
  /** Allow callers to extend layout related styles. */
  className?: string
}

export const AnnouncementPill: FC<AnnouncementPillProps> = ({
  label,
  className,
  type = 'button',
  ...props
}) => {
  const pillClassName = classNames('announcement-pill', className)

  return (
    <button type={type} className={pillClassName} {...props}>
      <span className="announcement-pill__layer announcement-pill__layer--base">
        {label}
      </span>
      <span
        aria-hidden="true"
        className="announcement-pill__layer announcement-pill__layer--blur"
      >
        {label}
      </span>
      <span
        aria-hidden="true"
        className="announcement-pill__layer announcement-pill__layer--ghost shine"
      >
        {label}
      </span>
    </button>
  )
}
